import * as React from 'react';
import Grid from '@mui/material/Grid';
import { InspectionContents } from '../../css/CSS.js';
import InspectionWarrantyListBody from './WarrantyListBody.js';

export default function WarrantyListFrame() {
    return (
        <InspectionContents sx={{ pb: 2, pt: 2, }} maxWidth="xl">
            < Grid sx={{ height: 64 }} />
            <Grid container columns={12} spacing={0} sx={{ pt: 2 }} maxWidth="xl" >
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <InspectionWarrantyListBody />
                </Grid>
            </Grid>
        </InspectionContents>
    );
}